import { isNil } from 'lodash-es';

export const urlFormat = (object: any) => {
	return Object.keys(object)
		.filter((key) => !isNil(object[key]))
		.map((key) => `${key}=${object[key]}`)
		.join('&');
};
